import styleText from './as-spinner.css?raw';

/**
 * Simple spinner component for loading states
 */
export class AsSpinner extends HTMLElement {
  private static readonly sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      AsSpinner.sheet
    ];

    this.shadowRoot!.innerHTML = /*html*/`
      <div class="spinner"></div>
    `;
  }
}

if (!customElements.get('as-spinner')) {
  customElements.define('as-spinner', AsSpinner);
} else {
  console.warn('as-spinner already defined');
}
